import { recoilPersist } from "recoil-persist";

export const { persistAtom } = recoilPersist({
    key: "lg-baloise-car",
    storage:
        typeof global?.window !== "undefined"
            ? global?.window?.sessionStorage
            : undefined,
});
